import { render, staticRenderFns } from "./subscriberLayout.vue?vue&type=template&id=d63cb780&scoped=true"
import script from "./subscriberLayout.vue?vue&type=script&lang=js"
export * from "./subscriberLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d63cb780",
  null
  
)

export default component.exports